import { isMock } from '../config'
import { fianzaMock } from './mock'
import { fianzaReal } from './real'
import type { FianzaService } from './types'

export const fianzaService: FianzaService = isMock('fianza') ? fianzaMock : fianzaReal
export type { ClaimInput, Deposit, DepositKind, DepositMilestone, DepositStatus, DepositTimelineItem, FianzaService } from './types'
